import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/compass': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M347.9 129.9c16.7-7.6 33.8 9.5 26.2 26.2l-66 144.3c-2.7 6-9.8 13-15.8 15.8l-144.3 66c-16.7 7.6-33.8-9.5-26.2-26.2l66-144.3c2.7-6 9.8-13 15.8-15.8zM270.6 278.6c12.5-12.5 12.5-32.7 0-45.2s-32.7-12.5-45.2 0-12.5 32.7 0 45.2 32.7 12.5 45.2 0zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/compass.js
// module id = 1719
// module chunks = 0